import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const AatbHeader = (props) => {
    const { activeTab, toggle, mmbrAatbList, setAatbList, courseGrpCdList } = props;
    const [tabInfo, setTabInfo] = useState([]);

    useEffect(() => {
        if (mmbrAatbList.length > 0 && Boolean(mmbrAatbList[0].COURSE_GRP_CD)) {
            /* 출판사 추출 */
            const setPbcmName = (course) => {
                const subject = mmbrAatbList.filter((value) => value.COURSE_GRP_CD === course);
                return subject.length > 0 && Boolean(subject[0].PBCM_NAME)
                    ? subject[0].PBCM_NAME + ((subject[0].AUTR_YN || "") === "Y" ? `(${subject[0].AUTR_NAME})` : "")
                    : "미설정";
            };

            const TEMP_TAB_INFO = {
                KORN: { className: "korean", subjectName: "국어", pbcmName: "미설정" },
                ENGM: { className: "english", subjectName: "영어", pbcmName: "미설정" },
                MATH: { className: "math", subjectName: "수학", pbcmName: "미설정" },
                SOSI: { className: "social", subjectName: "사회", pbcmName: "미설정" },
                HIST: { className: "history", subjectName: "역사", pbcmName: "미설정" },
                SCNE: { className: "science", subjectName: "과학", pbcmName: "미설정" },
            };

            let tempMmbrAatbList = [...mmbrAatbList];
            let tempAatbList = {};
            let tempTabInfo = [];

            const tempCourseGrpCdList = new Set(courseGrpCdList?.split(","));
            if (tempCourseGrpCdList.size > 0) {
                tempCourseGrpCdList.forEach((item) => {
                    if (!tempMmbrAatbList.some((value) => value.COURSE_GRP_CD === item)) {
                        tempMmbrAatbList.push({
                            AATB_SEQ: "",
                            AUTR_NAME: "",
                            AUTR_YN: "N",
                            PBCM_NAME: "",
                            COURSE_GRP_CD: item,
                        });
                    }
                });
            }

            if (tempMmbrAatbList.length > 0) {
                const priority = ["KORN", "ENGM", "MATH", "SOSI", "HIST", "SCNE"]; // 정렬 순서
                tempMmbrAatbList
                    .sort((a, b) => priority.indexOf(a.COURSE_GRP_CD) - priority.indexOf(b.COURSE_GRP_CD))
                    .forEach((item) => {
                        tempAatbList[item.COURSE_GRP_CD] = setPbcmName(item.COURSE_GRP_CD);
                    });

                // tabInfo 생성
                tempMmbrAatbList.forEach((item, index) => {
                    tempTabInfo.push({
                        className: TEMP_TAB_INFO?.[item.COURSE_GRP_CD]?.className || "",
                        subjectName: TEMP_TAB_INFO?.[item.COURSE_GRP_CD]?.subjectName || "",
                        pbcmName: tempAatbList?.[item.COURSE_GRP_CD] || "미설정",
                        active: String(index + 1), // active 생성
                        courseGrpCd: item.COURSE_GRP_CD,
                    });
                });
            }

            // console.log("%c ### mmbrAatbList :: ", "color: #ff6600;", mmbrAatbList);
            // console.log("%c ### tempAatbList :: ", "color: #ff6600;", tempAatbList);
            // console.log("%c ### tempTabInfo :: ", "color: #ff6600;", tempTabInfo);

            setAatbList(tempAatbList);
            setTabInfo(tempTabInfo);
        }
    }, [mmbrAatbList, setAatbList, courseGrpCdList]);

    return (
        <Nav tabs className="textbookTab">
            {tabInfo?.length > 0 &&
                tabInfo.map((item, idx) => (
                    <NavItem key={idx} className={classnames({ active: activeTab === item.active })}>
                        <NavLink
                            className={(classnames({ active: activeTab === item.active }), item.className)}
                            onClick={() => {
                                toggle(item.active);
                            }}
                        >
                            {item.subjectName}
                            <span>{item.pbcmName}</span>
                        </NavLink>
                    </NavItem>
                ))}
        </Nav>
    );
};

export default AatbHeader;
